const { FormRoot } = require('./FormRoot')

export const Form = {
  Root: FormRoot,
}
